exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cou-cell .weui_cell_primary p p{line-height:1.8}.cou-cell .weui_cell_primary p p .cou-label{width:3.04rem;display:inline-block;opacity:.4}.cou-cell .weui_cell_primary p .mb50{margin-bottom:.53333333rem}", ""]);

// exports
